import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './context/LanguageContext';
import { OrderProvider } from './context/OrderContext';
import Layout from './components/layout/Layout';
import OrderRouteGuard from './components/OrderRouteGuard';
import Home from './pages/Home';
import Upload from './pages/Upload';
import Payment from './pages/Payment';
import Success from './pages/Success';
import Services from './pages/Services';
import TranslationSummary from './pages/TranslitionOrder';
import Payment1 from './pages/Payment1';
import Cancel from './pages/Cancel';
import OrderTracking from './pages/OrderTracking';
import PrivacyPolicy from './pages/PrivacyPolicy/PrivacyPolicy';
import TermsConditions from './pages/TermsConditions/TermsConditions';
import RefundPolicy from './pages/RefundPolicy/RefundPolicy';
import './App.css';

function App() {
  return (
    <LanguageProvider>
      <OrderProvider>
        <Router>
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/services" element={
                <OrderRouteGuard requiredStep={1}>
                  <Services />
                </OrderRouteGuard>
              } />
              <Route path="/PrivacyPolicy" element={<PrivacyPolicy />} />
              <Route path="/TermsCondithions" element={<TermsConditions />} />
              <Route path="/RefundPolicy" element={<RefundPolicy />} />
              <Route path="/upload" element={<Upload />} />
              <Route path="/payment" element={<Payment />} />
              <Route path="/success" element={<Success />} />
              <Route path="/cancel" element={<Cancel />} />
              <Route path="/track-order" element={<OrderTracking />} />
              <Route path="/translation-summary" element={
                <OrderRouteGuard requiredStep={2}>
                  <TranslationSummary />
                </OrderRouteGuard>
              } />
              <Route path='/Payment1' element={
                <OrderRouteGuard requiredStep={3}>
                  <Payment1 />
                </OrderRouteGuard>
              } />
            </Routes>
          </Layout>
        </Router>
      </OrderProvider>
    </LanguageProvider>
  );
}

export default App;
